<button class="button-component" :class="computedClasses" :disabled="disabled" :style="computedStyles" @click="onClick"><slot></slot></button>